import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { loadCatalogo } from '../content/load.ts';
import { Callout } from '../components/primitives/index.tsx';
import { EstadoACarregar } from '../components/brand/LoadingMark.tsx';
import { t } from '../i18n/index.ts';
import './modulo.css';

/**
 * ADR 0027 — `/modulo/$moduleId` deixou de ter página própria a 05/09/2026:
 * o módulo é uma secção do curso, e vê-se na página do curso com essa secção
 * seleccionada. O endereço fica a existir porque há marcadores, ligações
 * partilhadas e o histórico do navegador a apontar-lhe — e um endereço que
 * dava uma página e passa a dar um ecrã em branco é uma sessão perdida.
 *
 * Reencaminha com `replace`, para o «voltar» do navegador não ficar preso
 * num ciclo entre os dois endereços.
 */
export function ModuloRoute() {
  const { moduleId } = useParams({ from: '/modulo/$moduleId' });
  const navigate = useNavigate();
  const [inexistente, setInexistente] = useState(false);

  useEffect(() => {
    const controlador = new AbortController();
    loadCatalogo(controlador.signal)
      .then((catalogo) => {
        const modulo = catalogo.modulos.find((m) => m.id === moduleId);
        if (!modulo) {
          setInexistente(true);
          return;
        }
        void navigate({
          to: '/curso/$trackId',
          params: { trackId: modulo.track },
          search: { seccao: modulo.id },
          replace: true,
        });
      })
      .catch(() => {
        if (!controlador.signal.aborted) setInexistente(true);
      });
    return () => controlador.abort();
  }, [moduleId, navigate]);

  if (inexistente) {
    return (
      <div className="pagina-modulo">
        <Callout tone="error" role="alert">
          <p>{t('modulo.inexistente')}</p>
        </Callout>
        <Link to="/" className="btn btn--primary">
          {t('catalogo.voltar')}
        </Link>
      </div>
    );
  }

  return (
    <div className="pagina-modulo">
      <EstadoACarregar texto={t('trilhas.acarregar')} />
    </div>
  );
}
